import { SamplesDeliveryType } from '@caresend/types';
import { nullishFilter } from '@caresend/utils';
import { TagStyle } from '../../../../../../ui/Tag/model.js';
import { getStore } from '../../../../../../../store/helpers/initStore.js';

const getCentrifugeTag = (procedure) => {
    var _a, _b;
    if (!((_b = (_a = procedure.supplyInstructionConfig) === null || _a === void 0 ? void 0 : _a.processingIncludes) === null || _b === void 0 ? void 0 : _b.centrifuge))
        return undefined;
    return {
        label: 'Centrifuge',
        icon: 'sync',
        tagStyle: TagStyle['4_PURPLE'],
    };
};
const getSamplesDeliveryTypeTag = (procedure) => {
    const { supplyInstructionConfig } = procedure;
    if (!supplyInstructionConfig)
        return undefined;
    const { samplesDeliveryType } = supplyInstructionConfig;
    switch (samplesDeliveryType) {
        case SamplesDeliveryType.MAIL_IN:
            return {
                label: 'Mail-in',
                icon: 'undo',
                tagStyle: TagStyle['4_BLUE'],
            };
        case SamplesDeliveryType.WALK_IN:
            return {
                label: 'Walk-in',
                icon: 'walking',
                tagStyle: TagStyle['4_GREEN'],
            };
    }
};
const getNursePackingTag = (procedure) => {
    const { supplyTransferID } = procedure;
    if (supplyTransferID) {
        return {
            label: 'Nurse packing off',
            icon: 'box',
            tagStyle: TagStyle['3_ORANGE'],
        };
    }
    return {
        label: 'Nurse packing',
        icon: 'box',
        tagStyle: TagStyle['4_GREEN'],
    };
};
const getSampleScanningDisabledTag = (procedure) => {
    const { disableSampleScanning } = procedure;
    if (disableSampleScanning) {
        return;
    }
    return {
        label: 'Sample scanning',
        icon: 'barcode',
        tagStyle: TagStyle['4_GREEN'],
    };
};
const getSampleProcessingDisabledTag = (procedure) => {
    const { disableSampleProcessing } = procedure;
    if (disableSampleProcessing) {
        return {
            label: 'Processing flow disabled',
            icon: 'toggle-off',
            tagStyle: TagStyle['4_PURPLE'],
        };
    }
};
const getLabTag = (procedure) => {
    var _a, _b, _c;
    const [placeGroupID] = Object.keys((_a = procedure.dropOffPlaceGroups) !== null && _a !== void 0 ? _a : {});
    if (!placeGroupID)
        return undefined;
    const placeGroup = (_b = getStore().state.places.placeGroups) === null || _b === void 0 ? void 0 : _b[placeGroupID];
    const procedureIsMailIn = ((_c = procedure.supplyInstructionConfig) === null || _c === void 0 ? void 0 : _c.samplesDeliveryType)
        === SamplesDeliveryType.MAIL_IN;
    const isMailInOnly = (placeGroup === null || placeGroup === void 0 ? void 0 : placeGroup.name) === 'Mail-in Only';
    if (!(placeGroup === null || placeGroup === void 0 ? void 0 : placeGroup.name) || (isMailInOnly && procedureIsMailIn))
        return undefined;
    return {
        label: placeGroup.name,
        icon: 'flask',
        tagStyle: TagStyle['4_BLACK'],
    };
};
const getProcedureTagInfos = (procedure) => [
    getCentrifugeTag(procedure),
    getSamplesDeliveryTypeTag(procedure),
    getNursePackingTag(procedure),
    getSampleScanningDisabledTag(procedure),
    getSampleProcessingDisabledTag(procedure),
    getLabTag(procedure),
].filter(nullishFilter);

export { getProcedureTagInfos };
